#include<ColorMapping>
#include<MaskTexture>

// GENERAL
uniform vec2 resolution;
uniform float visibility;
uniform vec4 shaderColor1;
uniform vec4 shaderColor2;
uniform float effectScale;
uniform float isLayer;

// MASK PARAM
uniform vec4 mouseTrailOffsetTime;
uniform vec4 textureOffsetTime;

// FILTERS
uniform float chromatic;
uniform float alpha;
uniform float blur;
uniform float pixel;
uniform float fisheye;
uniform float glass;
uniform float ripple;
uniform float grain;
uniform float invert;

/* Advise to improve shader
Use vector and matrix operations: GLSL is designed to work with vector and matrix operations, so try to take advantage of this by using built-in functions like dot, cross, and matrix multiplication instead of writing your own operations.

Avoid branching: Branching (if/else statements) can be expensive in shaders, so try to use boolean operators and built-in functions like mix or step instead whenever possible.
*/

//! smoothstep reverse alpha result on safari so we use the math equivalent
// as explpained here: https://registry.khronos.org/OpenGL-Refpages/gl4/html/smoothstep.xhtml
float smoothstepSafariCompatible(float edge0, float ege1, float x)
{ 
    float t = clamp((x - edge0) / (ege1 - edge0), 0.0, 1.0);
    return t * t * (3.0 - 2.0 * t);
}

float PI = 3.1415926;
float EaseInOutSine(float x)
{ 
    return -(cos(PI * x) - 1.0) / 2.0;
}

vec3 EaseInOutSineVec3(vec3 x)
{ 
    return -(cos(PI * x) - 1.0) / 2.0;
}

float addTimeToMask(float mask, vec4 offsetTime) {
    float maskWithTime = mod(mask + offsetTime.x + (offsetTime.y * time/50.), 2.);
    float minMask = min(maskWithTime, 2. - maskWithTime);
    minMask *= offsetTime.z;
    return minMask;
    //* Easing make the default image look wrong as it alter the default mask
    // return EaseInOutSine(minMask);
}

vec3 addTimeToMaskVec3(vec3 mask, vec4 offsetTime) {
    vec3 maskWithTime = mod(mask + offsetTime.x + (offsetTime.y * time/50.), 2.);
    vec3 minMask = min(maskWithTime, 2. - maskWithTime);
    minMask *= offsetTime.z;
    return minMask;
    // return EaseInOutSineVec3(minMask);
}

vec4 getFuryImage(float mouseTrailMask) {
    vec3 textureUVAndMask = getNoiseUVAndMask();
    vec2 noiseUV = textureUVAndMask.xy;

    float power = effectScale * 2.;

    vec2 textureUV;
    if (isLayer == 1.0) {
        textureUV = noiseUV;
    } else {
        textureUV = vUV;
        //! Can't use fract as it creates a border on text element
        // textureUV = fract(vUV);
    }

    ivec2 textureSize2d = textureSize(textureSampler,0);
    float textureX = float(textureSize2d.x);
    float textureY = float(textureSize2d.y);
    float textureRatio = textureX/textureY;


    float textureMask = textureUVAndMask.z;
    // If no texture mask, smooth size need to be one
    // float smooth_size = 1. - 0.7 * sqrt(textureOffsetTime.z + 0.5);
    float smooth_size = 1.;
    if (textureOffsetTime.z != 0.) smooth_size = 0.3;

    textureMask = textureMask * (1.0 - smooth_size) + smooth_size;
    float textureMaskWithTime = addTimeToMask(textureMask, textureOffsetTime);    
    float mouseTrailMaskWithTime = addTimeToMask(mouseTrailMask, mouseTrailOffsetTime);
    float filterMask = clamp(1. - (mouseTrailMaskWithTime + textureMaskWithTime), 0., 1.);


    // Pixel Effect
    if (pixel != 0.0) {
        // float filteredPixel = smoothstepSafariCompatible(1. - pixel, 1. - pixel + smooth_size, filterMask);
        // filteredPixel = filteredPixel * power / 5. + 0.0001;
        float filteredPixel = pixel * power * filterMask / 5. + 0.0001;

        float pixel_w = 0.1 * filteredPixel;
        float pixel_h = 0.1 * filteredPixel * textureRatio;
        vec2 pixeldUV = 2.0 * textureUV - 1.0;
    
        pixeldUV = vec2(
            pixel_w * floor(pixeldUV.x/pixel_w) + (pixel_w / 2.0), 
            pixel_h * floor(pixeldUV.y/pixel_h) + (pixel_h / 2.0)
        );
        textureUV = 0.5 * (pixeldUV + 1.0);
    }

    // Ripple Effect
    if (ripple != 0.0) {
        // float filteredRipple = smoothstepSafariCompatible(1. - ripple, 1. - ripple + smooth_size, filterMask);
        // filteredRipple = filteredRipple * power * 0.1 + 0.0001;
        float filteredRipple = ripple * power * filterMask * 0.1 + 0.0001;

        vec2 rippleUV = 2.0 * textureUV - 1.0;
        float d = length(rippleUV);
        if (d < 1.0) {
            rippleUV.x *= textureRatio;
            float freq = 20.0;
            float theta  = atan(rippleUV.y, rippleUV.x);
            float radius = length(rippleUV);
            radius = pow(radius, filteredRipple*sin(radius*freq)+1.0);
            // radius = pow(radius, power*sin(radius*freq-time*speed)+1.0);
            rippleUV.x = radius * cos(theta);
            rippleUV.y = radius * sin(theta);
            rippleUV.x /= textureRatio;
            textureUV = 0.5 * (rippleUV + 1.0);
        }
    }

    // Fisheye Effect
    if (fisheye != 0.0) {
        // float filteredFisheye = smoothstepSafariCompatible(1. - fisheye, 1. - fisheye + smooth_size, filterMask);
        // filteredFisheye = filteredFisheye * power * 0.1 + 0.0001;
        float filteredFisheye = fisheye * power * filterMask * 0.1 + 0.0001;

        float prop = resolution.x / resolution.y;
        vec2 m = vec2(0.5, 0.5 / prop);
        vec2 d = textureUV - m; // vector from center to current fragment
        float r = sqrt(dot(d, d)); // distance of pixel from center

        if (filteredFisheye >= 0.0)
            filteredFisheye *= 2.0;

        float bind;//radius of 1:1 effect
        if (filteredFisheye > 0.0) 
            bind = sqrt(dot(m, m));//stick to corners
        else {if (prop < 1.0) 
            bind = m.x; 
        else 
            bind = m.y;}//stick to borders

        //Weird formulas
        if (filteredFisheye > 0.01)//fisheye
            textureUV = m + normalize(d) * tan(r * filteredFisheye) * bind / tan( bind * filteredFisheye);
        else if (filteredFisheye < 0.01)//antifisheye
            textureUV = m + normalize(d) * atan(r * -filteredFisheye * 10.0) * bind / atan(-filteredFisheye * bind * 10.0);
            
    }

    // Glass Effect
    // if (glass != 0.0) {
    //     float displace = (filterMask - 0.5) * glass / 10.0;
    //     textureUV += vec2(displace);
    // }   

    vec4 originImage = texture2D(textureSampler, textureUV);

    // Chromatic & Blur Effect
    vec3 blurChromImage = originImage.rgb;
    if (blur != 0.0 || chromatic != 0.0) {
        // Chromatic effect
        // float filteredChromatic = smoothstepSafariCompatible(1. - chromatic, 1. - chromatic + smooth_size, filterMask);
        // filteredChromatic = filteredChromatic * power * 0.001;
        float filteredChromatic = chromatic * power * filterMask * 0.002;

        vec2 rUV = vec2(textureUV.x + filteredChromatic, textureUV.y + filteredChromatic);
        vec2 gUV = vec2(textureUV.x - filteredChromatic, textureUV.y + filteredChromatic);
        vec2 bUV = vec2(textureUV.x, textureUV.y - filteredChromatic);

        // Blur effect
        // float filteredBlur = smoothstepSafariCompatible(1. - blur, 1. - blur + smooth_size, filterMask);
        // filteredBlur = filteredBlur * power * 0.001;
        float filteredBlur = blur * power * filterMask * 0.001;

        int qualityInt = 15;
        float qualityFloat = 15.0;
        int halfQuality = 7;
        float weights[15] = float[15](0.004, 0.008, 0.016, 0.032, 0.07, 0.1, 0.15, 0.22, 0.15, 0.1, 0.07, 0.032, 0.016, 0.008, 0.004);

        vec2 texelStep = vec2(1.0, 1.0) * filteredBlur;
        vec2 texelStep2 = vec2(-1.0, 1.0) * filteredBlur;

        blurChromImage = vec3(0., 0., 0.);
        for (int i = 0; i < qualityInt; i++)
        {
            vec2 tc1 = texelStep * float(i - halfQuality);
            blurChromImage.r += weights[i] * texture2D(textureSampler, rUV + tc1).r;
            blurChromImage.g += weights[i] * texture2D(textureSampler, gUV + tc1).g;
            blurChromImage.b += weights[i] * texture2D(textureSampler, bUV + tc1).b;

            vec2 tc2 = texelStep2 * float(i - halfQuality);
            blurChromImage.r += weights[i] * texture2D(textureSampler, rUV + tc2).r;
            blurChromImage.g += weights[i] * texture2D(textureSampler, gUV + tc2).g;
            blurChromImage.b += weights[i] * texture2D(textureSampler, bUV + tc2).b;
        }
        blurChromImage /= 2.0;

        // float filteredBlur = blur * power * 0.002;
        // float Pi = 6.28318530718; // Pi*2
        // float Directions = 8.0; // BLUR DIRECTIONS (Default 16.0 - More is better but slower)
        // float Quality = 2.0; // BLUR QUALITY (Default 4.0 - More is better but slower)
        // blurChromImage = texture2D(textureSampler, textureUV).rgb;
        
        // for( float d = 0.0; d < Pi; d += Pi / Directions)
        // {
        //     for(float i = 1.0 / Quality; i <= 1.0; i += 1.0 / Quality)
        //     {
        //         vec2 tc = vec2(cos(d),sin(d)) * filteredBlur * i;
        //         blurChromImage.r += texture2D(textureSampler, rUV + tc).r;		
        //         blurChromImage.g += texture2D(textureSampler, gUV + tc).g;		
        //         blurChromImage.b += texture2D(textureSampler, bUV + tc).b;		
        //     }
        // }
        // blurChromImage /= Quality * Directions * 1.5;
    }

    // Color Effect
    vec3 colorImage = blurChromImage;
    vec3 hsl1 = shaderColor1.xyz;
    vec3 hsl2 = shaderColor2.xyz;
    vec3 rgb1 = hsl2rgb(hsl1);
    vec3 rgb2 = hsl2rgb(hsl2);

    if (isLayer == 1.0) {
        blurChromImage = addTimeToMaskVec3(blurChromImage, textureOffsetTime);
        blurChromImage = clamp(1. - (blurChromImage + mouseTrailMaskWithTime), 0., 1.);
        vec3 colorImage1 = blurChromImage * rgb1;
        vec3 colorImage2 = (1.0 - blurChromImage) * rgb2;
        colorImage = colorImage1 + colorImage2;
    } else {
        vec3 blendColorHsl1 = filterMask * hsl1;
        vec3 blendColorHsl2 = (1.0 - filterMask) * hsl2;
        vec3 blendColorHsl = blendColorHsl1 + blendColorHsl2;

        vec3 blendColorRgb1 = filterMask * rgb1;
        vec3 blendColorRgb2 = (1.0 - filterMask) * rgb2;
        vec3 blendColorRgb = blendColorRgb1 + blendColorRgb2;

        float lightness = blendColorHsl.b;
        float saturation = blendColorHsl.g;
        vec3 lightColor = colorImage * lightness;
        vec3 lightnessVec3 = vec3(0.5, 0.5, 0.5);
        float saturationDot = dot(lightColor, lightnessVec3);

        colorImage = mix(vec3(saturationDot), lightColor, saturation) * blendColorRgb;
    }

    // Invert Color Effect
    vec3 invertImage = colorImage;
    if (invert != 0.0) {
        float filteredInvert = smoothstepSafariCompatible(1. - invert, 1. - invert + smooth_size, filterMask);
        vec3 colorGap = 2.0 * colorImage - 1.0;
        invertImage = colorImage - colorGap * filteredInvert;
    }

    // Grain Effect
    vec3 grainImage = invertImage;
    if (grain != 0.0) {
        float filteredGrain = smoothstepSafariCompatible(1. - grain, 1. - grain + smooth_size, filterMask);
        filteredGrain = filteredGrain * power * 0.2;
        float noise = (fract(sin(dot(textureUV, vec2(12.9898,78.233)*2.0)) * 43758.5453));
        grainImage = grainImage - noise * filteredGrain;
    }

    // Alpha Effect
    float alphaMask = 1.;
    if (alpha != 0.0) {
        float filteredAlpha = smoothstepSafariCompatible(1. - alpha, 1. - alpha + smooth_size, filterMask);
        alphaMask = 1. - filteredAlpha;
    }



    // Visibility
    float alpha = originImage.w * alphaMask;
    // float alpha = originImage.w * alphaMask * visibility;
    // To fix Alpha issue between Mesh
    // Not needed anymore as alphaIndex works great
    // if (alpha == 0.) discard;

    vec4 alphaImage = vec4(grainImage, alpha);	
    return alphaImage;
}